import React from 'react';

const SubmissionHero = () => (
  <>
    <section className="relative">
      <div className="relative h-[300px] md:h-[400px] overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1519741497674-611481863552?w=1600&h=800&fit=crop"
          alt="Share your wedding story"
          className="w-full h-full object-cover"
              loading="lazy"
              decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-[#FAF9F7]"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center px-4">
            <p className="text-white/90 text-xs tracking-[0.3em] uppercase mb-4">
              WEDDING STORY SUBMISSION
            </p>
            <h1
              className="text-4xl md:text-6xl text-white mb-4 tracking-tight drop-shadow-lg"
              style={{ fontFamily: '"Playfair Display", serif' }}
            >
              Share Your Love Story
            </h1>
          </div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-12">
        <div className="w-20 h-0.5 mx-auto mb-8" style={{ backgroundColor: '#DE92A9' }}></div>
        <p className="text-[#757B7F] text-lg leading-relaxed max-w-2xl mx-auto">
          Let's tell your love story your way! We want your story to feel as unique and joyful
          as the celebration itself.
        </p>
      </div>
    </section>

    <section className="py-12 bg-white border-b border-[#E5E0DA]">
      <div className="max-w-3xl mx-auto px-4 text-center">
        <p className="text-[#6B4E37] text-lg leading-relaxed">
          Thank you so much for choosing to share your beautiful day with I Do. Fill this out together,
          laugh, reminisce, and don't hold back on the little details that made it truly yours.
        </p>
        <p className="text-[#DE92A9] font-medium mt-4">
          Photos, tears, puppy cameos, unexpected dance breaks, we want it all!
        </p>
      </div>
    </section>
  </>
);

export default SubmissionHero;
